/**
 * AgentsActionCard — Dashboard Build Engine P4 (2026-07-28).
 *
 * Agents action card: once the tenant has said what needs to get done
 * (Business Profile Q4), offer an advisory Pi routine that recommends which of
 * their agents (Pi / Hermes / OpenClaw / Goose) fit the work and how to use them
 * from the Terminals tab. Advisory by design — the seed names only real tools /
 * surfaces (no fabricated agent-messaging tool). Shared ActionCard +
 * startPiRoutine + buildAgentsSeed. §6 (Q4 → agents to run/message/manage).
 */
import { Bot } from 'lucide-react';
import { useDashboardStore } from '@/stores/dashboardStore';
import { ActionCard } from './ActionCard';
import { runBuildStep, buildAgentsSeed } from './buildEngine';

export function AgentsActionCard() {
  const tasks = useDashboardStore((s) => s.profile.tasks);
  const status = useDashboardStore((s) => s.buildState.agents);
  const setBuildStepStatus = useDashboardStore((s) => s.setBuildStepStatus);

  // Which agents help keys off the "what needs to get done" answer (Q4).
  if (!tasks.trim()) return null;

  return (
    <ActionCard
      testId="agents-action-card"
      icon={<Bot className="h-5 w-5" />}
      title="Put your agents to work"
      description="Find out which of your agents can help with what needs to get done."
      preview={tasks}
      previewTestId="agents-action-preview"
      buttonLabel="Set up my agents"
      buttonTestId="agents-action-start"
      onAction={() => void runBuildStep('agents', buildAgentsSeed(tasks))}
      status={status ?? 'todo'}
      onMarkDone={() => void setBuildStepStatus('agents', 'done')}
      onReopen={() => void setBuildStepStatus('agents', 'todo')}
    />
  );
}

export default AgentsActionCard;
